<template>
<CheckODBalToGL/>
</template>

<script>
import CheckODBalToGL from '../../../components/Gl/CheckODBalToGL/CheckODBalToGL.vue';

export default {
  components: {
    CheckODBalToGL,
  },
};

</script>
